export default "__VITE_ASSET__3a8f4f21__"